import type { LimitKind, LimitResource } from '@/api/errors'
import { trackLimitReached } from '@/services/metrikaGoals'
import { useCommonStore } from '@/stores/common'
import { usePaywallStore } from '@/stores/paywall'
import { useUsageStore } from '@/stores/usage'

/**
 * Лимит исчерпан по ответу сервера (axios-интерсептор и SSE). 429 бывает и обычным
 * рейт-лимитом авторизованного, поэтому предлагаем войти только гостю.
 */
export function handleLimitExceeded(kind: LimitKind, resource?: LimitResource): void {
	const usage = useUsageStore()
	if (kind === 'guest') {
		if (!usage.isGuest) return
		// Сервер — истина: обнуляем локальный счётчик, дальше гостя тормозит useFeatureGate.
		usage.exhaustGuest()
		useCommonStore().openLoginModal()
		trackLimitReached('guest')
		return
	}
	// Лимит тарифа. Гостю тариф не предлагаем — openLimitDialog отправит его во вход.
	// Сервер — истина: обнуляем остаток, дальше клиентский гейт не пустит запрос.
	// Порядок важен: openLimitDialog смотрит на остатки, чтобы выбрать вариант шторки.
	usage.exhaustResource(resource ?? 'text')
	usePaywallStore().openLimitDialog(resource ?? 'text')
	trackLimitReached('plan', resource ?? 'text')
}
